import React from "react";
import { CourseFormFieldApi } from "api";
import { useDictionariesOptions } from "api/hooks";
import { ApplicationFieldForm } from "./ApplicationFieldForm";
import { PaziaLoader } from "components/atoms";
import { PaziaModal } from "components/molecules";
import { FormFieldSchema } from "components/templates/AddApplicationFormGroupModal/ApplicationForm";

interface AddApplicationFormFieldModalProps {
  onCloseRequest: () => void;
  onSubmit: (data: FormFieldSchema) => void;
  field: CourseFormFieldApi | null;
  allFields: CourseFormFieldApi[];
}

export const AddApplicationFormFieldModal = ({
  onCloseRequest,
  field,
  onSubmit,
  allFields,
}: AddApplicationFormFieldModalProps) => {
  const { loading: loadingDictionaries, options: dictionariesOptions } = useDictionariesOptions();

  return (
    <PaziaModal id="craete-topic-modal" onCloseRequest={onCloseRequest} isOpen={!!field} size="4xl">
      <div className="min-h-[50vh] px-5 pb-6 pt-4">
        <div className="text-xl">
          <div className="mb-2 font-medium text-slate-800 dark:text-slate-100">
            {field?.id ? "Edycja pola" : "Dodaj nowe pole"}
          </div>
        </div>
        {loadingDictionaries ? (
          <PaziaLoader />
        ) : (
          field && (
            <ApplicationFieldForm
              field={field}
              allFields={allFields}
              dictionaries={dictionariesOptions}
              onSubmit={onSubmit}
              onCancel={onCloseRequest}
            />
          )
        )}
      </div>
    </PaziaModal>
  );
};
